import React from 'react';
import { AppButton, Box, NewTabIcon, PlusThinIcon } from '@common-fe/common-fe';
import styled from 'styled-components';

import ROUTES from '@/common/routes';
import { ButtonHintForTerminatedEmployer } from '@/modules/employer/components/EmployerTermination/ButtonHintForTerminatedEmployer';
import { EmployerStatus } from '@/modules/employer/employer.constants';
import { useMyMoneyReimbursementFeatureFlag } from '@/modules/UseMyMoney/hooks';

import TopbarIconButton from '../EmployeeTopbar/TopbarIconButton';

import { useEmployeeEnrollmentParams } from './queries/useEmployeeEnrollmentParams';

const SUBMIT_CLAIM_BUTTON_WIDTH = '160px';
const TERMINATED_ORG_TOOLTIP_TEXT = 'Terminated Organization cannot add enrollment';
const PLANS_POLICY_RUNOUT_TOOLTIP_TEXT = 'Terminated plans cannot add new enrollment';

const StyledButtonsWrapp = styled(Box)`
  > div:not(:first-child) {
    margin-left: 12px;
  }
`;

interface EnrollmentModalActionsProps {
  isEdit: boolean;
  isWithoutButton?: boolean;
  onSetVisible: (value: boolean) => void;
  isAddingEnrollmentAvailable: boolean;
  isAddingHealthPlanEnrollmentAvailable: boolean;
  isLoading: boolean;
  status: string;
  isAllPlansHasPolicyRunout: boolean;
  hasSubmitClaimButton?: boolean;
  children?: React.ReactNode;
}

const EnrollmentModalActions: React.FC<EnrollmentModalActionsProps> = ({
  isEdit,
  isWithoutButton,
  onSetVisible,
  isAddingEnrollmentAvailable,
  isAddingHealthPlanEnrollmentAvailable,
  isLoading,
  status,
  isAllPlansHasPolicyRunout,
  hasSubmitClaimButton,
  children,
}) => {
  const { employeeId } = useEmployeeEnrollmentParams();
  const { isUseMyMoneyReimbursementEnabled } = useMyMoneyReimbursementFeatureFlag();

  if (isEdit || isWithoutButton) return null;

  const isAddEnrollmentDisabled =
    (!isAddingEnrollmentAvailable && !isAddingHealthPlanEnrollmentAvailable) ||
    isLoading ||
    status === EmployerStatus.Terminated ||
    isAllPlansHasPolicyRunout;

  return (
    <StyledButtonsWrapp direction="row">
      <ButtonHintForTerminatedEmployer
        button={
          <TopbarIconButton
            testId="EnrollmentModal-open-modal"
            title="Add Enrollment"
            icon={(
              <PlusThinIcon
                size="24px"
                color={isAddEnrollmentDisabled ? 'iconSecondary' : 'iconPrimary'}
              />
            )}
            onClick={() => onSetVisible(true)}
            disabled={isAddEnrollmentDisabled}
          />
        }
        isTerminatedEmployer={status === EmployerStatus.Terminated || isAllPlansHasPolicyRunout}
        hintText={isAllPlansHasPolicyRunout ? PLANS_POLICY_RUNOUT_TOOLTIP_TEXT : TERMINATED_ORG_TOOLTIP_TEXT}
      />
      {children}
      {hasSubmitClaimButton ? (
        <AppButton
          testId="Redirect-reimburse-page"
          width={SUBMIT_CLAIM_BUTTON_WIDTH}
          onClick={() => {
            if (isUseMyMoneyReimbursementEnabled) {
              window.open(`${ROUTES.USE_MY_MONEY(employeeId)}${window.location.search}`, '_blank');
              return;
            }
            window.open(`${ROUTES.REIMBURSE_ME(employeeId)}${window.location.search}`, '_blank');
          }}
          rightIcon={<NewTabIcon />}
        >
          Submit Claim
        </AppButton>
      ) : null}
    </StyledButtonsWrapp>
  );
};

export default EnrollmentModalActions;
